import _jsx from "@babel/runtime/helpers/jsx";
var _span;
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import hasDom from 'has-dom';
import AlertAutoClose from '../AlertAutoClose/index.js';

/**
 * GlobalAlert displays on top of the page.
 * Dismisses after timeout or by clicking the close button in the component.
 */
function GlobalAlert(props) {
  // This could be further simplified but react-docgen chokes on && shorthand
  if (hasDom()) {
    return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(AlertAutoClose, props), document.body);
  }
  return _span || (_span = /*#__PURE__*/_jsx("span", {}));
}
export default GlobalAlert;